import { useEffect, useState, FC } from "react";

import "./dev.scss";
import { ScheduledJobModel, listScheduledJob } from "@rubi/api-generated";
import { Link } from "react-router-dom";

import {
  JsonPre,
  Breadcrumbs,
  Crumb,
  DevPage,
  ErrorMsg,
  JsonObject,
  Section,
} from "./common";

const ScheduledJob: FC<ScheduledJobModel> = ({
  id,
  group_id,
  time_execute,
  job_desc,
  job_topic,
}) => (
  <tr>
    <td className="mono">{id}</td>
    <td className="mono">{group_id}</td>
    <td>{job_topic}</td>
    <td>{<JsonPre object={time_execute} />}</td>
    <td>{<JsonPre object={job_desc as JsonObject} />}</td>
  </tr>
);

const ScheduledJobTable: FC<{ jobs: ScheduledJobModel[] }> = ({ jobs }) => {
  return (
    <table className="dev-table">
      <thead>
        <tr>
          <th>id</th>
          <th>group_id</th>
          <th>job_topic</th>
          <th>time_execute</th>
          <th>job_desc</th>
        </tr>
      </thead>
      <tbody>
        {jobs.map((scheduledJob) => (
          <ScheduledJob key={scheduledJob.id} {...scheduledJob} />
        ))}
      </tbody>
    </table>
  );
};

export const DevScheduledJobsPage: FC = () => {
  const [scheduledJobsList, setScheduledJobsList] = useState<
    ScheduledJobModel[]
  >([]);
  const [error, setError] = useState<string | null>(null);

  const loadScheduledJobs = async () => {
    const response = await listScheduledJob({ throwOnError: false });
    if (response.status === 200) {
      const data = response.data!;
      setScheduledJobsList(data);
      setError(null);
    } else {
      setScheduledJobsList([]);
      setError("" + response.status + " " + response.error?.console_msg);
      console.log(response);
    }
  };

  useEffect(() => {
    loadScheduledJobs();
  }, []);

  return (
    <DevPage
      title="Scheduled Jobs"
      breadcrumbs={
        <Breadcrumbs>
          <Crumb>
            <Link to="/">Home</Link>
          </Crumb>
          <Crumb>
            <Link to="/dev_admin">Developer and Administrator Utilities</Link>
          </Crumb>
          <Crumb>Scheduled Jobs</Crumb>
        </Breadcrumbs>
      }
    >
      <Section>
        <button onClick={loadScheduledJobs}>Reload</button>
        <ErrorMsg msg={error} />
        <ScheduledJobTable jobs={scheduledJobsList} />
      </Section>
    </DevPage>
  );
};
